module.exports = __webpack_public_path__ + "static/assets/e8f72b7df19a975343a7f6419652f8d5.svg";